import { pgTable, text, doublePrecision, timestamp, index, jsonb } from 'drizzle-orm/pg-core'
import { relations } from 'drizzle-orm'
import type { Measurement } from '../../../measurements'
import { id, createdAt, updatedAt } from '../utils/columns'
import { entities } from '../entities/entities.schema'
import { catalogItems } from '../catalog/catalog.schema'
import { receivables } from './receivables.schema'

export const jobCatalogItems = pgTable(
  'job_catalog_items',
  {
    id,
    entityId: text('entity_id')
      .notNull()
      .references(() => entities.id),
    jobId: text('job_id').notNull(),
    jobTypeId: text('job_type_id').notNull(),
    catalogItemId: text('catalog_item_id')
      .notNull()
      .references(() => catalogItems.id),
    quantity: doublePrecision('quantity').notNull(),
    /** Aufmaß: internal rows whose sum is `quantity`; carried onto the invoice line. See `measurements.ts`. */
    measurements: jsonb('measurements').$type<Measurement[]>(),
    usedReceivableId: text('used_receivable_id'),
    usedAt: timestamp('used_at', { mode: 'date' }),
    createdAt,
    updatedAt,
  },
  (table) => [
    index('idx_job_catalog_items_entity_job').on(table.entityId, table.jobTypeId, table.jobId),
    index('idx_job_catalog_items_catalog_item').on(table.catalogItemId),
  ],
)

export type JobCatalogItem = typeof jobCatalogItems.$inferSelect
export type JobCatalogItemInsert = typeof jobCatalogItems.$inferInsert

export const jobCatalogItemsRelations = relations(jobCatalogItems, ({ one }) => ({
  entity: one(entities, {
    fields: [jobCatalogItems.entityId],
    references: [entities.id],
  }),
  catalogItem: one(catalogItems, {
    fields: [jobCatalogItems.catalogItemId],
    references: [catalogItems.id],
  }),
  usedReceivable: one(receivables, {
    fields: [jobCatalogItems.usedReceivableId],
    references: [receivables.id],
  }),
}))
